import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  const { fill = "#55CD1D", size = 24 } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm5.589 7.368l-6.391 6.341a.983.983 0 01-1.378.025l-3.384-3.082a1.016 1.016 0 01-.075-1.404.992.992 0 011.403-.05l2.682 2.456L16.16 7.94a.999.999 0 011.429 0 .999.999 0 010 1.428z"
        fill={fill}
      />
    </Svg>
  );
}

export default SvgComponent;
